export default __webpack_public_path__ + "static/media/samsungLogo.32329462.svg";